import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  container: {
    padding: 8
  },
  select: {
    display: 'flex',
    padding: 10,
    borderRadius: 6,
    cursor: 'pointer',
    '&:hover': {
      background: '#f7f7f8'
    }
  },
  label: {
    marginLeft: 10,
    fontSize: 14,
    fontWeight: 400
  },
  sectionTitle: {
    color: '#6A728F',
    fontSize: 12,
    marginTop: 4,
    marginLeft: 12,
    marginBottom: 10
  }
}));

type State = {
  approved: boolean;
  applicationWaiting: boolean; // Waiting on delegate to complete application
  responsesWaiting: boolean; // Waiting on references to complete responses
  approvalWaiting: boolean; // Waiting on TTC to approve background check
};

type Props = {
  onChange?: (state: State) => void;
  state: State;
};

// created -> application -> responses -> approved

export default function FilterOptions({ state, onChange }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.sectionTitle}>STATUS</div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              applicationWaiting: false,
              responsesWaiting: false,
              approvalWaiting: false,
              approved: !state.approved
            });
        }}
      >
        <input type="checkbox" checked={state.approved} />
        <div className={classes.label}>Approved</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              applicationWaiting: false,
              responsesWaiting: false,
              approved: false,
              approvalWaiting: !state.approvalWaiting
            });
        }}
      >
        <input type="checkbox" checked={state.approvalWaiting} />
        <div className={classes.label}>Approval required</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              applicationWaiting: false,
              approvalWaiting: false,
              approved: false,
              responsesWaiting: !state.responsesWaiting
            });
        }}
      >
        <input type="checkbox" checked={state.responsesWaiting} />
        <div className={classes.label}>Waiting on references</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              responsesWaiting: false,
              approvalWaiting: false,
              approved: false,
              applicationWaiting: !state.applicationWaiting
            });
        }}
      >
        <input type="checkbox" checked={state.applicationWaiting} />
        <div className={classes.label}>Waiting on delegate</div>
      </div>
    </div>
  );
}
